import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DeliveriesPane, AdditionPane, AreasPoolPane, ExternalLoadPane, HoursPane } from './navigator-components';
import { Tab, Menu, Label, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import { switchDeliveryTab } from '../../../actions';

import './Delivery.scss';

class DeliveryNavigator extends Component {

    constructor(props) {
        super(props);

        this.switchTab = this.switchTab.bind(this);
    }

    switchTab(event, { activeIndex }) {
        this.props.clearDrawnDeliveryZonesFromMap();
        this.props.switchDeliveryTab(activeIndex);
    }

    render() {
        const {
            activeTab,
            restaurant,
            areasStatus,
            editDeliveryArea,
            saveDeliveryAreaEdit,
            cancelDeliveryAreaEdit,
            removeDeliveryArea,
            addNewDeliveryAreas,
            numberOfDraftedDeliveryAreas,
            drawDeliveryZonesOnMap,
            clearDrawnDeliveryZonesFromMap
        } = this.props;

        const panes = [
            {
                menuItem: (
                    <Menu.Item key='deliveries' className='pi-delivery-areas-tab'>
                        <Icon name='marker' />
                        {i18next.t('deliveryAreas')}
                        {restaurant.deliveryAreas && restaurant.deliveryAreas.length > 0 &&
                            <Label color={activeTab === 0 ? 'blue' : 'grey'} basic className='pi-delivery-areas-tab-label'>
                                {restaurant.deliveryAreas.length}
                            </Label>}
                    </Menu.Item>
                ),
                render: () => {
                    return (
                        <DeliveriesPane
                            restaurant={restaurant}
                            editDeliveryArea={editDeliveryArea}
                            saveDeliveryAreaEdit={saveDeliveryAreaEdit}
                            cancelDeliveryAreaEdit={cancelDeliveryAreaEdit}
                            removeDeliveryArea={removeDeliveryArea}
                            areasStatus={areasStatus}
                           
                        />
                    );
                }
            },
            {
                menuItem: { key: 'addition', icon: 'add', color: 'blue', content: i18next.t('deliveryAreaAddition') }, render: () => {
                    return (
                        <AdditionPane
                            addNewDeliveryAreas={addNewDeliveryAreas}
                            numberOfDraftedDeliveryAreas={numberOfDraftedDeliveryAreas}
                           
                        />
                    );
                }
            },
            {
                menuItem: { key: 'pool', icon: 'database', color: 'blue', content: i18next.t('deliveryAreasPool') }, render: () => {
                    return (
                        <AreasPoolPane
                            addNewDeliveryAreas={addNewDeliveryAreas}
                            drawDeliveryZonesOnMap={drawDeliveryZonesOnMap}
                            clearDrawnDeliveryZonesFromMap={clearDrawnDeliveryZonesFromMap}
                           
                        />
                    );
                }
            },
            {
                menuItem: { key: 'external', icon: 'external', color: 'blue', content: i18next.t('externalLoading') }, render: () => {
                    return (
                        <ExternalLoadPane
                            addNewDeliveryAreas={addNewDeliveryAreas}
                            drawDeliveryZonesOnMap={drawDeliveryZonesOnMap}
                            clearDrawnDeliveryZonesFromMap={clearDrawnDeliveryZonesFromMap}
                           
                        />
                    );
                }
            },
            {
                menuItem: { key: 'hours', icon: 'time', color: 'blue', content: i18next.t('deliveryHours') }, render: () => {
                    return (
                        <HoursPane
                            restaurant={restaurant}
                           
                        />
                    );
                }
            }
        ];

        return (
            <Tab
                menu={{ color: 'blue', secondary: true, pointing: true }}
                panes={panes}
                activeIndex={activeTab}
                onTabChange={this.switchTab} />
        );
    }
}

DeliveryNavigator.propTypes = {
    restaurant: PropTypes.object,
    areasStatus: PropTypes.object,

    addNewDeliveryAreas: PropTypes.func,
    removeDeliveryArea: PropTypes.func,

    editDeliveryArea: PropTypes.func,
    saveDeliveryAreaEdit: PropTypes.func,
    cancelDeliveryAreaEdit: PropTypes.func,

    numberOfDraftedDeliveryAreas: PropTypes.func,

    drawDeliveryZonesOnMap: PropTypes.func,
    clearDrawnDeliveryZonesFromMap: PropTypes.func,

    switchDeliveryTab: PropTypes.func,
    
};

const mapStateToProps = (state, ownProps) => {
    const { activeTab } = state.businessApp.delivery;

    return { activeTab };
};
export default connect(mapStateToProps, { switchDeliveryTab })(DeliveryNavigator);
